import template from './outstanding_data_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class OutstandingDataHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class OutstandingDataHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new OutstandingDataHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'OutstandingDataHelp',
	dialog_class: OutstandingDataHelpPage,
	template: template,
	template_filename: 'translation/dialogs/outstanding_data_help',
	provider: 'ps'
};
